import { render } from "./TrashButton.vue?vue&type=template&id=06fefedc&scoped=true"
import script from "./TrashButton.vue?vue&type=script&lang=js"
export * from "./TrashButton.vue?vue&type=script&lang=js"

import "./TrashButton.vue?vue&type=style&index=0&id=06fefedc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06fefedc"

export default script